import classNames from 'classnames';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import AddImageItem from 'components/AddImageItem';
import ImageBox from 'components/ImageBox';
import { ImageMap } from 'models';
import * as Models from 'models';
import { mobileViewImageSelector } from './selectors';
import styles from './styles.module.scss';

type Props = {
  mobileViewImage: Models.BackgroundImageMap;
  className?: string;
  toggleMobileViewImage(image: Models.BackgroundImageMap): void;
  dataTestId?: string;
};

const MobileViewImage: React.FunctionComponent<Props> = (props) => {
  const { imagesForAssetsPanel, documentIdsAreBeingUploaded } = useSelector(mobileViewImageSelector);

  const {
    mobileViewImage,
    toggleMobileViewImage,
    className,
    dataTestId = 'mobileViewImage',
  } = props;

  function isActive(image: ImageMap): boolean {
    return image.get('id') === mobileViewImage.get('id')
    || image.get('documentId') === mobileViewImage.get('documentId');
  }

  const setImage = useCallback(
    (imageId: string, number: number, image: ImageMap): void => {
      if (!isActive(image)) {
        toggleMobileViewImage(
          mobileViewImage.set('id', imageId).set('documentId', number),
        );

        return;
      }

      toggleMobileViewImage(
        mobileViewImage.set('id', null).delete('documentId'),
      );

    },
    [mobileViewImage, toggleMobileViewImage],
  );

  return (
    <div className={classNames(styles.MobileViewImage, className)} data-testid={dataTestId}>
      <ul className={styles.list} data-testid={`${dataTestId}-list`}>
        <div className={styles.item} data-testid={`${dataTestId}-list-itemEmpty`}>
          <AddImageItem />
        </div>

        {imagesForAssetsPanel.valueSeq().toArray().map((image, index) => {
          const imageId = image.get('id');

          return (
            <li className={styles.item} key={imageId} data-testid={`${dataTestId}-list-item${index}`}>
              <ImageBox
                image={image}
                isActive={isActive(image)}
                isImageBeingUploaded={documentIdsAreBeingUploaded.has(imageId)}
                onImageClick={setImage}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default MobileViewImage;
